module.exports = "/_next/static/images/8bac31e533872e41e62cea449ac0a424-highFive.svg";